import React, { useState, useEffect } from "react";
import { Button, Table, message } from "antd";
import { Link, useNavigate } from "react-router-dom";
import { EditTwoTone } from "@ant-design/icons";
import axiosInstance from "@/axios/axiosInstance";
import "./index.scss";

const Video = () => {
  let navigate = useNavigate();
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);
  const [videoList, setVideoList] = useState([]);
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
    total: 0,
  });
  const rowSelection = {
    selectedRowKeys,
    onChange: (selectedKeys, selectedRows) => {
      setSelectedRowKeys(selectedKeys);
      setSelectedRows(selectedRows);
    },
  };
  const getVideoList = async (
    page = pagination.current,
    limit = pagination.pageSize
  ) => {
    try {
      const response = await axiosInstance.get(
        `/video/account/list?page=${page}&limit=${limit}`
      );
      setVideoList(response.data.data);
      setPagination({
        ...pagination,
        current: page,
        total: response.data.page.totalCount,
      });
    } catch (error) {
      console.error("Error fetching user info:", error);
    }
  };
  useEffect(() => {
    getVideoList(); // 组件挂载后获取用户信息
  }, []); // 空依赖数组确保只运行一次// 空数组作为依赖项表示这个 effect 只在组件挂载时运行一次
  const videoShow = () => {
    const formData = new FormData();
    formData.append("videoIdArray", selectedRowKeys.join(","));
    formData.append("status", 1);

    try {
      axiosInstance
        .post("video/account/update", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then((response) => {
          if (response.data.code === 10000) {
            getVideoList(pagination.current, pagination.pageSize);
            message.success("修改成功");
          }
        })
        .catch((error) => {
          // 处理错误情况
          console.error("Error fetching user info:", error);
        });
    } catch (error) {
      // 处理错误情况
      console.error("Error fetching user info:", error);
    }
  };
  const videoDisable = () => {
    const formData = new FormData();
    formData.append("videoIdArray", selectedRowKeys.join(","));
    formData.append("status", 2);

    try {
      axiosInstance
        .post("video/account/update", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then((response) => {
          if (response.data.code === 10000) {
            getVideoList(pagination.current, pagination.pageSize);
            message.success("修改成功");
          }
        })
        .catch((error) => {
          // 处理错误情况
          console.error("Error fetching user info:", error);
        });
    } catch (error) {
      // 处理错误情况
      console.error("Error fetching user info:", error);
    }
  };
  const deleteCom = () => {
    const formData = new FormData();
    formData.append("videoIdArray", selectedRowKeys.join(","));
    formData.append("deleteFlag", "1");

    try {
      axiosInstance
        .post("video/account/update", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then((response) => {
          if (response.data.code === 10000) {
            getVideoList(pagination.current, pagination.pageSize);
            message.success("修改成功");
          }
        })
        .catch((error) => {
          // 处理错误情况
          console.error("Error fetching user info:", error);
        });
    } catch (error) {
      // 处理错误情况
      console.error("Error fetching user info:", error);
    }
  };
  const toDetail = (record) => {
    navigate("/publishVideo", { state: { id: record.videoId } });
  };
  const columns = [
    {
      title: "视频标题/标签",
      dataIndex: "title",
      width: "35%",
      ellipsis: true,
      render: (text, record, k) => {
        return (
          <span>
            <img src={`${record.cover}`} className="title_name_img" alt="" />
            {record.title}
          </span>
        );
      },
    },
    {
      title: "发布日期",
      dataIndex: "createTime",
      width: "20%",
    },
    {
      title: "状态",
      dataIndex: "status",
      width: "20%",
      render: (text, record, k) => {
        return <span>{text === 1 ? "展示" : "隐藏"}</span>;
      },
    },
    {
      title: "操作",
      dataIndex: "we",
      width: "25%",
      render(t, record) {
        // <CloseCircleTwoTone />
        return (
          <span>
            <EditTwoTone
              style={{ marginRight: "10px" }}
              onClick={() => toDetail(record)}
            />
          </span>
        );
      },
    },
  ];
  const onRow = (record) => ({
    onClick: (event) => {
      const isSelected = selectedRowKeys.includes(record.videoId);
      let newSelectedRowKeys = isSelected
        ? selectedRowKeys.filter((key) => key !== record.videoId)
        : [...selectedRowKeys, record.videoId];
      // 你可以在这里添加其他逻辑，比如如果只想单选，就清空其他选中的项
      setSelectedRowKeys(newSelectedRowKeys);
      setSelectedRows(
        newSelectedRowKeys.map((key) =>
          videoList.find((item) => item.videoId === key)
        )
      );
    },
  });
  useEffect(() => {
    getVideoList();
  }, [pagination.current, pagination.pageSize]);
  const handleTableChange = (pagination, filters, sorter) => {
    setPagination({
      ...pagination,
    });
  };
  const handlePageSizeChange = (value) => {
    setPagination({
      ...pagination,
      pageSize: value,
      current: 1,
    });
  };

  const pageSizeOptions = ["10", "20", "50", "100"];
  const paginationLocale = {
    items_per_page: "/页",
    jump_to: "跳至",
    jump_to_confirm: "确认",
    page: "页",
    prev_page: "上一页",
    next_page: "下一页",
    prev_5: "向前 5 页",
    next_5: "向后 5 页",
    total_items: "共 {total} 条",
    total_pages: "共 {total} 页",
  };

  const showTotal = (total, range) => {
    return `共 ${total} 条`;
  };
  return (
    <div className="personal_right">
      <div className="personal_right_top">
        <Button
          type="primary"
          onClick={() => {
            window.open("/publishVideo", "_blank");
          }}
        >
          发布
        </Button>
        <Button
          type="primary"
          onClick={videoShow}
          disabled={!selectedRowKeys.length}
          style={{ color: "white" }}
        >
          展示
        </Button>
        <Button onClick={videoDisable} disabled={!selectedRowKeys.length}>
          隐藏
        </Button>
        <Button
          type="dashed"
          disabled={!selectedRowKeys.length}
          onClick={deleteCom}
        >
          删除
        </Button>
      </div>
      <div className="personal_right_bot">
        <Table
          onRow={onRow}
          rowSelection={rowSelection}
          columns={columns}
          dataSource={videoList}
          rowKey={(record) => record.videoId}
          scroll={{ y: "42vh" }}
          pagination={{
            ...pagination,
            showSizeChanger: true,
            pageSizeOptions: pageSizeOptions,
            onShowSizeChange: (current, size) => handlePageSizeChange(size),
            showTotal: showTotal,
            locale: paginationLocale,
          }}
          onChange={handleTableChange}
        />
      </div>
    </div>
  );
};
export default Video;
